/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Actions_Report_IssueInputs */



/**
* | output |
* | --- |
* | "Report Issue" |
*
* @param {Error_Actions_Report_IssueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const error_actions_report_issue = /** @type {((inputs?: Error_Actions_Report_IssueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Actions_Report_IssueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Problem melden")
	return /** @type {LocalizedString} */ ("Report Issue")
});